import React, {Component} from 'react';

import {connect} from 'react-redux'
import {Redirect, Navigate} from 'react-router-dom'
import {Link, useParams} from 'react-router-dom';

import Config from '../Helpers/Config'
import Loader from "../Components/Loader";

class Home extends Component {
    render() {
        // return <div>Home</div>
        console.log('this.props.auth.business',this.props.auth.business)
        if (this.props.auth.fetched) {
            if (!this.props.auth.business) {
                window.location = `${Config.mainUrl('business/submit')}`;
                return;
            }
            if (this.props.match.params.businessSlug) {
                return <Navigate replace to={{pathname: `/${this.props.match.params.businessSlug}/orders`}}/>
            } else {

                return <Navigate replace to={{pathname: `/${this.props.auth.business.slug}/orders`}}/>
            }
        }


        return (<Loader completed={this.props.auth.fetched}></Loader>)

    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Home);
